define("shared/utils/profile-categorization-values", ["exports", "@ember/object", "later/utils/array-methods"], function (_exports, _object, _arrayMethods) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getIndustries = _exports.getCategories = _exports.getBusinessTypes = _exports.getBusinessModels = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"later/utils/array-methods"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class profileCategorizationValues
   * @extends Utils
   */
  /**
   * Wraps array of industry config objects with the intl service
   *
   * @method getIndustries
   * @param {Service} intl The intl service
   * @param {Boolean} [makeEmberObj=false] Whether to convert each industry to an ember object
   *
   * @returns {Array} Array of config objects for profile categorization industries
   */
  const getIndustries = function (intl) {
    let makeEmberObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const industries = [{
      name: intl.t('profile_categorization.industries.design'),
      value: 'design',
      keywords: ['design', 'graphic design', 'industrial design', 'web design', 'architecture']
    }, {
      name: intl.t('profile_categorization.industries.finance_business'),
      value: 'finance_business',
      keywords: ['finance', 'accounting', 'insurance', 'consulting', 'entrepreneurship', 'recruiting', 'business services']
    }, {
      name: intl.t('profile_categorization.industries.government_law'),
      value: 'government_law',
      keywords: ['politics', 'government', 'law', 'legal']
    }, {
      name: intl.t('profile_categorization.industries.entertainment'),
      value: 'entertainment',
      keywords: ['entertainment', 'event', 'festival', 'venue', 'theatre', 'film', 'movie', 'cinema', 'toys', 'games', 'video games', 'gaming', 'books', 'magazine', 'comics', 'erotic']
    }, {
      name: intl.t('profile_categorization.industries.restaurant'),
      value: 'restaurant',
      keywords: ['restaurant', 'bakery', 'cafe', 'bar']
    }, {
      name: intl.t('profile_categorization.industries.real_estate_construction'),
      value: 'real_estate_construction',
      keywords: ['real estate', 'buildings', 'construction', 'home improvement', 'architecture', 'renovation']
    }, {
      name: intl.t('profile_categorization.industries.fashion_apparel'),
      value: 'fashion_apparel',
      keywords: ['fashion', 'apparel', 'clothing', 'sewing', 'fashion design', 'costumes', 'cosplay', 'model']
    }, {
      name: intl.t('profile_categorization.industries.makeup_beauty'),
      value: 'makeup_beauty',
      keywords: ['makeup', 'beauty', 'hair', 'skin', 'cosmetics', 'personal care', 'model', 'tattoos', 'piercing']
    }, {
      name: intl.t('profile_categorization.industries.jewelry_accessories'),
      value: 'jewelry_accessories',
      keywords: ['jewelry', 'accessories', 'bags']
    }, {
      name: intl.t('profile_categorization.industries.shoes_footwear'),
      value: 'shoes_footwear',
      keywords: ['shoes', 'footwear']
    }, {
      name: intl.t('profile_categorization.industries.music'),
      value: 'music',
      keywords: ['music']
    }, {
      name: intl.t('profile_categorization.industries.humor'),
      value: 'humor',
      keywords: ['humor', 'memes', 'comedy']
    }, {
      name: intl.t('profile_categorization.industries.sports_fitness'),
      value: 'sports_fitness',
      keywords: ['sport', 'gym', 'exercise', 'dance', 'yoga', 'fitness']
    }, {
      name: intl.t('profile_categorization.industries.marketing'),
      value: 'marketing',
      keywords: ['marketing services', 'advertising', 'social media', 'communications']
    }, {
      name: intl.t('profile_categorization.industries.photography'),
      value: 'photography',
      keywords: ['photography', 'videography', 'gallery']
    }, {
      name: intl.t('profile_categorization.industries.news_media'),
      value: 'news_media',
      keywords: ['news', 'media', 'podcasts', 'tv', 'television', 'youtube']
    }, {
      name: intl.t('profile_categorization.industries.food_beverage'),
      value: 'food_beverage',
      keywords: ['food', 'beverage', 'wine', 'beer', 'coffee', 'cooking', 'grocery', 'supermarket', 'dessert', 'chocolate']
    }, {
      name: intl.t('profile_categorization.industries.health_wellness'),
      value: 'health_wellness',
      keywords: ['health', 'wellness', 'nutrition', 'medicine', 'dentistry', 'health care', 'optometry', 'psychology', 'mental health']
    }, {
      name: intl.t('profile_categorization.industries.family_children'),
      value: 'family_children',
      keywords: ['family', 'children', 'baby', 'kids', 'motherhood', 'parenting', 'fatherhood', 'toys', 'games']
    }, {
      name: intl.t('profile_categorization.industries.home_decor_furnishings'),
      value: 'home_decor_furnishings',
      keywords: ['home decor', 'furnishings', 'decor', 'decorations', 'interior design', 'furniture']
    }, {
      name: intl.t('profile_categorization.industries.wedding_bridal'),
      value: 'wedding_bridal',
      keywords: ['wedding', 'bridal']
    }, {
      name: intl.t('profile_categorization.industries.animals'),
      value: 'animals',
      keywords: ['animals', 'pets', 'veterinary', 'dogs', 'cats', 'fish', 'horses']
    }, {
      name: intl.t('profile_categorization.industries.travel_tourism'),
      value: 'travel_tourism',
      keywords: ['travel', 'tourism', 'accomodation', 'hotel', 'hospitality', 'museum']
    }, {
      name: intl.t('profile_categorization.industries.outdoors_nature'),
      value: 'outdoors_nature',
      keywords: ['outdoor', 'nature', 'camping', 'fishing', 'surfing', 'cycling', 'hunting', 'gardening', 'plants', 'floristry', 'conservation', 'environment', 'farming', 'agriculture']
    }, {
      name: intl.t('profile_categorization.industries.technology'),
      value: 'technology',
      keywords: ['technology', 'engineering', 'software', 'internet', 'computers', 'mobile', 'it']
    }, {
      name: intl.t('profile_categorization.industries.automotive'),
      value: 'automotive',
      keywords: ['automotive', 'vehicles', 'cars', 'motorcycles', 'aircraft', 'planes', 'boats']
    }, {
      name: intl.t('profile_categorization.industries.motivation'),
      value: 'motivation',
      keywords: ['motivation']
    }, {
      name: intl.t('profile_categorization.industries.education'),
      value: 'education',
      keywords: ['education', 'school', 'college', 'university', 'coaching', 'leadership', 'library', 'books']
    }, {
      name: intl.t('profile_categorization.industries.spirituality_philosophy'),
      value: 'spirituality_philosophy',
      keywords: ['spirituality', 'philosophy']
    }, {
      name: intl.t('profile_categorization.industries.arts_culture'),
      value: 'arts_culture',
      keywords: ['art', 'culture', 'author', 'crafts', 'diy', 'knitting', 'illustration', 'animation', '3d art', 'drawing', 'painting', 'literature', 'writing', 'poetry', 'books', 'comics', 'dance', 'gallery', 'museum', 'tattoos', 'piercing']
    }, {
      name: intl.t('profile_categorization.industries.luxury'),
      value: 'luxury',
      keywords: ['luxury']
    }, {
      name: intl.t('profile_categorization.industries.lifestyle'),
      value: 'lifestyle',
      keywords: ['lifestyle']
    }, {
      name: intl.t('profile_categorization.industries.personal'),
      value: 'personal',
      keywords: ['personal']
    }, {
      name: intl.t('profile_categorization.industries.religious'),
      value: 'religious',
      keywords: ['religious', 'church']
    }, {
      name: intl.t('profile_categorization.industries.relationships'),
      value: 'relationships',
      keywords: ['relationships']
    }];
    return makeEmberObj ? industries.map(industry => _object.default.create(industry)) : industries;
  };

  /**
   * Calls @getIndustries, and finds the industry
   * matching the given value
   *
   * @method _getIndustry
   * @param {String} value
   * @param {Service} intl The intl service
   * @protected
   *
   * @returns {Object} The industry matching the given value
   */
  _exports.getIndustries = getIndustries;
  const _getIndustry = (value, intl) => getIndustries(intl, false).find(industry => industry.value === value);

  /**
   * Wraps categories object with the intl service
   *
   * @method getCategories
   * @param {Service} intl The intl service
   *
   * @returns {Array} Array of config objects for profile categorization categories
   */
  const getCategories = intl => [{
    categoryId: 1,
    name: intl.t('profile_categorization.categories.fashion'),
    value: 'fashion',
    categoryIconClass: 'tSC--grid__icon--fashion',
    industries: _randomizeObjects([{
      key: 'fashion_apparel',
      isRandom: true
    }, {
      key: 'makeup_beauty',
      isRandom: true
    }, {
      key: 'jewelry_accessories',
      isRandom: true
    }, {
      key: 'shoes_footwear',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 2,
    name: intl.t('profile_categorization.categories.entertainment_media'),
    value: 'entertainment_media',
    categoryIconClass: 'tSC--grid__icon--media',
    industries: _randomizeObjects([{
      key: 'music',
      isRandom: true
    }, {
      key: 'entertainment',
      isRandom: true
    }, {
      key: 'humor',
      isRandom: true
    }, {
      key: 'sports_fitness',
      isRandom: true
    }, {
      key: 'news_media',
      isRandom: true
    }, {
      key: 'photography',
      isRandom: true
    }, {
      key: 'marketing',
      isRandom: false
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 3,
    name: intl.t('profile_categorization.categories.food'),
    value: 'food',
    categoryIconClass: 'tSC--grid__icon--food',
    industries: _randomizeObjects([{
      key: 'food_beverage',
      isRandom: true
    }, {
      key: 'restaurant',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 4,
    name: intl.t('profile_categorization.categories.home'),
    value: 'home',
    categoryIconClass: 'tSC--grid__icon--home',
    industries: _randomizeObjects([{
      key: 'real_estate_construction',
      isRandom: true
    }, {
      key: 'family_children',
      isRandom: true
    }, {
      key: 'home_decor_furnishings',
      isRandom: true
    }, {
      key: 'wedding_bridal',
      isRandom: true
    }, {
      key: 'animals',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 5,
    name: intl.t('profile_categorization.categories.active'),
    value: 'active',
    categoryIconClass: 'tSC--grid__icon--active',
    industries: _randomizeObjects([{
      key: 'health_wellness',
      isRandom: true
    }, {
      key: 'travel_tourism',
      isRandom: true
    }, {
      key: 'outdoors_nature',
      isRandom: true
    }, {
      key: 'sports_fitness',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 6,
    name: intl.t('profile_categorization.categories.interests_hobbies'),
    value: 'interests_hobbies',
    categoryIconClass: 'tSC--grid__icon--hobbies',
    industries: _randomizeObjects([{
      key: 'animals',
      isRandom: true
    }, {
      key: 'technology',
      isRandom: true
    }, {
      key: 'automotive',
      isRandom: true
    }, {
      key: 'photography',
      isRandom: true
    }, {
      key: 'travel_tourism',
      isRandom: true
    }, {
      key: 'sports_fitness',
      isRandom: true
    }, {
      key: 'music',
      isRandom: true
    }, {
      key: 'outdoors_nature',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 7,
    name: intl.t('profile_categorization.categories.education_improvement'),
    value: 'education_improvement',
    categoryIconClass: 'tSC--grid__icon--education',
    industries: _randomizeObjects([{
      key: 'finance_business',
      isRandom: true
    }, {
      key: 'government_law',
      isRandom: true
    }, {
      key: 'motivation',
      isRandom: true
    }, {
      key: 'education',
      isRandom: true
    }, {
      key: 'spirituality_philosophy',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }, {
      key: 'animals',
      isRandom: true
    }, {
      key: 'technology',
      isRandom: true
    }, {
      key: 'marketing',
      isRandom: false
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 8,
    name: intl.t('profile_categorization.categories.art_design'),
    value: 'art_design',
    categoryIconClass: 'tSC--grid__icon--art',
    industries: _randomizeObjects([{
      key: 'design',
      isRandom: true
    }, {
      key: 'arts_culture',
      isRandom: true
    }, {
      key: 'photography',
      isRandom: true
    }, {
      key: 'home_decor_furnishings',
      isRandom: true
    }, {
      key: 'music',
      isRandom: true
    }, {
      key: 'jewelry_accessories',
      isRandom: true
    }, {
      key: 'marketing',
      isRandom: false
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 9,
    name: intl.t('profile_categorization.categories.lifestyle'),
    value: 'lifestyle',
    categoryIconClass: 'tSC--grid__icon--lifestyle',
    industries: _randomizeObjects([{
      key: 'luxury',
      isRandom: true
    }, {
      key: 'home_decor_furnishings',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }, {
      key: 'makeup_beauty',
      isRandom: true
    }, {
      key: 'animals',
      isRandom: true
    }, {
      key: 'travel_tourism',
      isRandom: true
    }, {
      key: 'lifestyle',
      isRandom: false
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 10,
    name: intl.t('profile_categorization.categories.personal'),
    value: 'personal',
    categoryIconClass: 'tSC--grid__icon--personal',
    industries: _randomizeObjects([{
      key: 'photography',
      isRandom: true
    }, {
      key: 'travel_tourism',
      isRandom: true
    }, {
      key: 'makeup_beauty',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }, {
      key: 'humor',
      isRandom: true
    }, {
      key: 'personal',
      isRandom: false
    }]).map(key => _getIndustry(key, intl))
  }, {
    categoryId: 11,
    name: intl.t('profile_categorization.categories.spiritual_relationships'),
    value: 'spiritual_relationships',
    categoryIconClass: 'tSC--grid__icon--spiritual',
    industries: _randomizeObjects([{
      key: 'religious',
      isRandom: true
    }, {
      key: 'spirituality_philosophy',
      isRandom: true
    }, {
      key: 'relationships',
      isRandom: true
    }, {
      key: 'wedding_bridal',
      isRandom: true
    }, {
      key: 'health_wellness',
      isRandom: true
    }, {
      key: 'family_children',
      isRandom: true
    }]).map(key => _getIndustry(key, intl))
  }];

  /**
   * Randomizes the elements in the array with isRandom = true
   * and extracts out the keys
   *
   * @method _randomizeObjects
   * @param {Array} arr
   * @protected
   *
   * @returns {Array} A randomized array of object keys
   */
  _exports.getCategories = getCategories;
  const _randomizeObjects = arr => {
    const randomArr = (0, _arrayMethods.randomizeArray)(arr.filter(_ref => {
      let {
        isRandom
      } = _ref;
      return isRandom;
    })).map(_ref2 => {
      let {
        key
      } = _ref2;
      return key;
    });
    const nonRandomArr = arr.filter(_ref3 => {
      let {
        isRandom
      } = _ref3;
      return !isRandom;
    }).map(_ref4 => {
      let {
        key
      } = _ref4;
      return key;
    });
    return [...randomArr, ...nonRandomArr];
  };

  /**
   * Wraps Business Model question object with the intl service
   *
   * @method getQuestions
   * @param {Service} intl The intl service
   * @param {String} nickname
   *
   *
   * @returns {Object} A hash of all possible business model questions
   */
  const getQuestions = (intl, nickname) => ({
    where_create_sell: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.where_create_sell', {
        nickname
      }),
      needs: ['product_manufacturer'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.one_location'),
        valuesToRemove: ['app_software', 'brand', 'e_commerce_online_store', 'retail_chain']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.multiple_locations'),
        valuesToRemove: ['app_software', 'e_commerce_online_store', 'physical_store_location']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.online'),
        valuesToRemove: ['physical_store_location', 'product_manufacturer', 'retail_chain']
      }]
    },
    where_sell: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.where_sell', {
        nickname
      }),
      needs: ['personal_non_business'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.one_location'),
        valuesToRemove: ['app_software', 'brand', 'e_commerce_online_store', 'retail_chain', 'personal_non_business']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.multiple_locations'),
        valuesToRemove: ['app_software', 'e_commerce_online_store', 'physical_store_location', 'personal_non_business']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.online'),
        valuesToRemove: ['physical_store_location', 'product_manufacturer', 'retail_chain', 'personal_non_business']
      }]
    },
    where_provide: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.where_provide', {
        nickname
      }),
      needs: ['retail_chain'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.one_location'),
        valuesToRemove: ['app_software', 'e_commerce_online_store', 'retail_chain']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.multiple_locations'),
        valuesToRemove: ['app_software', 'e_commerce_online_store', 'physical_store_location']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.online'),
        valuesToRemove: ['destination', 'physical_store_location', 'retail_chain']
      }]
    },
    how_big: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.how_big', {
        nickname
      }),
      needs: ['agency'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.one_person'),
        valuesToRemove: ['agency', 'brand', 'retail_chain']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.multiple_people'),
        valuesToRemove: ['freelancer']
      }]
    },
    content_goal: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.content_goal'),
      needs: ['publication_broadcast_media'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.attract_customers'),
        valuesToRemove: ['community', 'non_profit', 'personal_non_business', 'fan_engagement']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.share_content'),
        valuesToRemove: ['agency', 'community', 'freelancer', 'non_profit', 'publication_broadcast_media', 'fan_engagement']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.build_audience'),
        valuesToRemove: ['agency', 'personal_non_business', 'non_profit']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.promote_cause'),
        valuesToRemove: ['agency', 'freelancer', 'personal_non_business', 'fan_engagement']
      }]
    },
    content_who: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.content_who'),
      needs: ['fan_engagement', 'community'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.shared_interest'),
        valuesToRemove: ['fan_engagement', 'publication_broadcast_media']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.readers_viewers'),
        valuesToRemove: ['fan_engagement', 'e_commerce_online_store']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.fans_supporters'),
        valuesToRemove: ['non_profit', 'publication_broadcast_media', 'freelancer']
      }]
    },
    profile_goal: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.profile_goal', {
        nickname
      }),
      needs: ['destination'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.attract_customers'),
        valuesToRemove: ['blog_influencer', 'community', 'non_profit', 'personal_non_business', 'fan_engagement', 'destination']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.promote_location'),
        valuesToRemove: ['blog_influencer', 'community', 'non_profit', 'personal_non_business', 'fan_engagement']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.share_content'),
        valuesToRemove: ['agency', 'community', 'destination', 'freelancer', 'non_profit', 'physical_store_location', 'fan_engagement', 'retail_chain']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.promote_event'),
        valuesToRemove: ['agency', 'destination', 'freelancer', 'physical_store_location', 'personal_non_business', 'fan_engagement', 'retail_chain']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.build_audience'),
        valuesToRemove: ['agency', 'destination', 'non_profit', 'physical_store_location', 'personal_non_business', 'retail_chain']
      }]
    },
    target_audience: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.target_audience', {
        nickname
      }),
      needs: ['community'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.shared_interest'),
        valuesToRemove: ['personal_non_business', 'fan_engagement', 'destination', 'freelancer']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.family_friends'),
        valuesToRemove: ['community', 'destination', 'non_profit', 'physical_store_location', 'fan_engagement', 'freelancer']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.fans_supporters'),
        valuesToRemove: ['destination', 'non_profit', 'physical_store_location', 'freelancer', 'personal_non_business']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.travelers'),
        valuesToRemove: ['non_profit', 'personal_non_business', 'fan_engagement', 'freelancer']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.none'),
        valuesToRemove: ['community', 'fan_engagement', 'destination']
      }]
    },
    target_audience_fan: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.target_audience', {
        nickname
      }),
      needs: ['fan_engagement'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.shared_interest'),
        valuesToRemove: ['fan_engagement']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.fans_supporters'),
        valuesToRemove: []
      }]
    },
    does_sell: {
      text: intl.t('profile_categorization.categorize_form.business_model.questions.does_sell', {
        nickname
      }),
      needs: ['product_manufacturer'],
      selectedAnswer: null,
      isAnswered: false,
      answers: [{
        text: intl.t('profile_categorization.categorize_form.business_model.answers.yes'),
        valuesToRemove: ['product_manufacturer']
      }, {
        text: intl.t('profile_categorization.categorize_form.business_model.answers.no'),
        valuesToRemove: ['personal_non_business']
      }]
    }
  });

  /**
   * Calls @getQuestions, and finds the business model
   * question matching the given value
   *
   * @method _getQuestion
   * @param {String} value
   * @param {Service} intl
   * @param {String} nickname
   * @protected
   *
   * @returns {Object} The business model question matching the given value
   */
  const _getQuestion = (value, intl, nickname) => {
    const question = getQuestions(intl, nickname)[value];
    return question ? _object.default.create(question) : null;
  };

  /**
   * Mappings of business model types to the associated business model keys
   *
   * @property {Object} businessModelMappings
   */
  const businessModelMappings = {
    products: {
      baseValues: [{
        key: 'app_software',
        isRandom: true
      }, {
        key: 'e_commerce_online_store',
        isRandom: true
      }, {
        key: 'physical_store_location',
        isRandom: true
      }, {
        key: 'product_manufacturer',
        isRandom: true
      }, {
        key: 'retail_chain',
        isRandom: true
      }, {
        key: 'freelancer',
        isRandom: true
      }, {
        key: 'personal_non_business',
        isRandom: true
      }, {
        key: 'brand',
        isRandom: false
      }],
      valuesToAdd: [],
      valuesToRemove: []
    },
    service: {
      baseValues: [{
        key: 'agency',
        isRandom: true
      }, {
        key: 'app_software',
        isRandom: true
      }, {
        key: 'destination',
        isRandom: true
      }, {
        key: 'freelancer',
        isRandom: true
      }, {
        key: 'physical_store_location',
        isRandom: true
      }, {
        key: 'community',
        isRandom: false
      }, {
        key: 'retail_chain',
        isRandom: false
      }, {
        key: 'non_profit',
        isRandom: false
      }],
      valuesToAdd: [{
        key: 'e_commerce_online_store',
        isRandom: true
      }],
      valuesToRemove: []
    },
    content: {
      baseValues: [{
        key: 'blog_influencer',
        isRandom: true
      }, {
        key: 'publication_broadcast_media',
        isRandom: true
      }, {
        key: 'personal_non_business',
        isRandom: true
      }, {
        key: 'fan_engagement',
        isRandom: true
      }, {
        key: 'community',
        isRandom: true
      }, {
        key: 'agency',
        isRandom: false
      }, {
        key: 'freelancer',
        isRandom: false
      }],
      valuesToAdd: [{
        key: 'e_commerce_online_store',
        isRandom: true
      }, {
        key: 'non_profit',
        isRandom: true
      }],
      valuesToRemove: []
    },
    experience: {
      baseValues: [{
        key: 'blog_influencer',
        isRandom: true
      }, {
        key: 'community',
        isRandom: true
      }, {
        key: 'destination',
        isRandom: true
      }, {
        key: 'fan_engagement',
        isRandom: true
      }, {
        key: 'physical_store_location',
        isRandom: true
      }, {
        key: 'personal_non_business',
        isRandom: false
      }],
      valuesToAdd: [{
        key: 'non_profit',
        isRandom: true
      }, {
        key: 'freelancer',
        isRandom: true
      }, {
        key: 'retail_chain',
        isRandom: true
      }, {
        key: 'agency',
        isRandom: true
      }],
      valuesToRemove: []
    },
    none: {
      baseValues: [{
        key: 'community',
        isRandom: true
      }, {
        key: 'destination',
        isRandom: true
      }, {
        key: 'non_profit',
        isRandom: true
      }, {
        key: 'personal_non_business',
        isRandom: true
      }, {
        key: 'fan_engagement',
        isRandom: true
      }, {
        key: 'freelancer',
        isRandom: false
      }],
      valuesToAdd: [{
        key: 'blog_influencer',
        isRandom: true
      }, {
        key: 'physical_store_location',
        isRandom: true
      }],
      valuesToRemove: [{
        key: 'agency',
        isRandom: false
      }]
    }
  };

  /**
   * Wraps Business Types object with the intl service
   *
   * @method getBusinessTypes
   * @param {Service} intl The intl service
   * @param {String} nickname
   *
   * @returns {Object} The config object for profile categorization Business Types
   */
  const getBusinessTypes = (intl, nickname) => {
    const getExtraValues = businessType => businessModelMappings[businessType].valuesToAdd;
    return [{
      name: intl.t('profile_categorization.business_types.products'),
      value: 'products',
      businessModels: _randomizeObjects([...businessModelMappings.products.baseValues, ...getExtraValues('products')]).map(key => _getBusinessModel(key, intl)),
      questions: ['does_sell', 'where_create_sell', 'where_sell'].map(value => _getQuestion(value, intl, nickname))
    }, {
      name: intl.t('profile_categorization.business_types.service'),
      value: 'service',
      businessModels: _randomizeObjects([...businessModelMappings.service.baseValues, ...getExtraValues('service')]).map(key => _getBusinessModel(key, intl)),
      questions: ['where_provide', 'how_big'].map(value => _getQuestion(value, intl, nickname))
    }, {
      name: intl.t('profile_categorization.business_types.content'),
      value: 'content',
      businessModels: _randomizeObjects([...businessModelMappings.content.baseValues, ...getExtraValues('content')]).map(key => _getBusinessModel(key, intl)),
      questions: ['content_goal', 'how_big', 'content_who'].map(value => _getQuestion(value, intl, nickname))
    }, {
      name: intl.t('profile_categorization.business_types.experience'),
      value: 'experience',
      businessModels: _randomizeObjects([...businessModelMappings.experience.baseValues, ...getExtraValues('experience')]).map(key => _getBusinessModel(key, intl)),
      questions: ['profile_goal', 'how_big', 'target_audience_fan'].map(value => _getQuestion(value, intl, nickname))
    }, {
      name: intl.t('profile_categorization.business_types.none'),
      value: 'none',
      businessModels: _randomizeObjects([...businessModelMappings.none.baseValues, ...getExtraValues('none')]).map(key => _getBusinessModel(key, intl)),
      questions: ['target_audience'].map(value => _getQuestion(value, intl, nickname))
    }];
  };

  /**
   * Calls @getBusinessModels, and finds the business model
   * matching the given value
   *
   * @method _getBusinessModel
   * @param {String} value
   * @param {Service} intl
   * @protected
   *
   * @returns {Object} The business model matching the given value
   */
  _exports.getBusinessTypes = getBusinessTypes;
  const _getBusinessModel = (value, intl) => getBusinessModels(intl).find(businessModel => businessModel.value === value);

  /**
   * Wraps Business Models object with the intl service
   *
   * @method getBusinessModels
   * @param {Service} intl
   *
   * @returns {Object} The config object for profile categorization Business Models
   */
  const getBusinessModels = intl => [{
    name: intl.t('profile_categorization.business_models.brand'),
    description: intl.t('profile_categorization.business_models.brand_description'),
    value: 'brand',
    keywords: ['brand', 'consumer brand', 'brand name'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.brand'),
    imageUrl: 'https://images.unsplash.com/photo-1564271239004-2071332b16af?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.brand')
  }, {
    name: intl.t('profile_categorization.business_models.fan_engagement'),
    description: intl.t('profile_categorization.business_models.fan_engagement_description'),
    value: 'fan_engagement',
    keywords: ['sports team', 'band', 'musician', 'celebrity', 'fan engagement', 'author', 'actor', 'actress', 'politician'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.fan_engagement'),
    imageUrl: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.fan_engagement')
  }, {
    name: intl.t('profile_categorization.business_models.destination'),
    description: intl.t('profile_categorization.business_models.destination_description'),
    value: 'destination',
    keywords: ['destination', 'hotel'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.destination'),
    imageUrl: 'https://images.unsplash.com/photo-1542115222561-1c49a2be1d70?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.destination')
  }, {
    name: intl.t('profile_categorization.business_models.retail_chain'),
    description: intl.t('profile_categorization.business_models.retail_chain_description'),
    value: 'retail_chain',
    keywords: ['retail chain', 'chain store', 'restaurant chain', 'hotel chain'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.retail_chain'),
    imageUrl: 'https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.retail_chain')
  }, {
    name: intl.t('profile_categorization.business_models.agency'),
    description: intl.t('profile_categorization.business_models.agency_description'),
    value: 'agency',
    keywords: ['agency', 'consultancy', 'service', 'real estate group', 'construction company', 'firm', 'catering company'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.agency'),
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.agency')
  }, {
    name: intl.t('profile_categorization.business_models.product_manufacturer'),
    description: intl.t('profile_categorization.business_models.product_manufacturer_description'),
    value: 'product_manufacturer',
    keywords: ['product manufacturer', 'manufacturer'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.product_manufacturer'),
    imageUrl: 'https://images.unsplash.com/photo-1576256932046-62148e2efdce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.product_manufacturer')
  }, {
    name: intl.t('profile_categorization.business_models.publication_broadcast_media'),
    description: intl.t('profile_categorization.business_models.publication_broadcast_media_description'),
    value: 'publication_broadcast_media',
    keywords: ['publication', 'tv', 'radio', 'broadcast media', 'podcast', 'publisher', 'print', 'news website', 'newspaper', 'magazine'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.publication_broadcast_media'),
    imageUrl: 'https://images.unsplash.com/photo-1557804506-e969d7b32a4b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.publication_broadcast_media')
  }, {
    name: intl.t('profile_categorization.business_models.e_commerce_online_store'),
    description: intl.t('profile_categorization.business_models.e_commerce_online_store_description'),
    value: 'e_commerce_online_store',
    keywords: ['e-commerce', 'ecommerce', 'online store', 'store', 'shop', 'webshop', 'retail online store'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.e_commerce_online_store'),
    imageUrl: 'https://images.unsplash.com/photo-1582004531564-50f300aae039?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.e_commerce_online_store')
  }, {
    name: intl.t('profile_categorization.business_models.physical_store_location'),
    description: intl.t('profile_categorization.business_models.physical_store_location_description'),
    value: 'physical_store_location',
    keywords: ['physical store', 'location', 'store', 'restaurant', 'studio', 'clinic', 'hospital', 'salon', 'shop', 'retail store', 'mall', 'gym', 'bar', 'gallery'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.physical_store_location'),
    imageUrl: 'https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-1.2.1&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.physical_store_location')
  }, {
    name: intl.t('profile_categorization.business_models.app_software'),
    description: intl.t('profile_categorization.business_models.app_software_description'),
    value: 'app_software',
    keywords: ['app', 'app development', 'application', 'game development', 'software development', 'saas', 'web application', 'mobile application'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.app_software'),
    imageUrl: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.app_software')
  }, {
    name: intl.t('profile_categorization.business_models.community'),
    description: intl.t('profile_categorization.business_models.community_description'),
    value: 'community',
    keywords: ['community', 'school', 'university', 'college', 'event', 'festival', 'church', 'educational institution', 'fan page', 'gaming forum', 'club / group'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.community'),
    imageUrl: 'https://images.unsplash.com/photo-1519671845924-1fd18db430b8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.community')
  }, {
    name: intl.t('profile_categorization.business_models.freelancer'),
    description: intl.t('profile_categorization.business_models.freelancer_description'),
    value: 'freelancer',
    keywords: ['freelancer', 'contractor', 'photographer', 'consultant', 'artist', 'coach', 'dj', 'service', 'realtor', 'author', 'writer', 'designer', 'advisor', 'therapist', 'producer', 'caterer'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.freelancer'),
    imageUrl: 'https://images.unsplash.com/photo-1522079091912-1694092d395e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.freelancer')
  }, {
    name: intl.t('profile_categorization.business_models.blog_influencer'),
    description: intl.t('profile_categorization.business_models.blog_influencer_description'),
    value: 'blog_influencer',
    keywords: ['blogger', 'influencer', 'celebrity', 'streamer', 'game streamer', 'art blog', 'design blog'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.blog_influencer'),
    imageUrl: 'https://images.unsplash.com/photo-1582004531674-ca3744ec120a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.blog_influencer')
  }, {
    name: intl.t('profile_categorization.business_models.personal_non_business'),
    description: intl.t('profile_categorization.business_models.personal_non_business_description'),
    value: 'personal_non_business',
    keywords: ['personal', 'non-business', 'just for fun'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.personal_non_business'),
    imageUrl: 'https://images.unsplash.com/photo-1550290129-72c1d23797ff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.personal_non_business')
  }, {
    name: intl.t('profile_categorization.business_models.non_profit'),
    description: intl.t('profile_categorization.business_models.non_profit_description'),
    value: 'non_profit',
    keywords: ['non-profit', 'not-for-profit', 'church', 'school', 'university', 'college', 'charity', 'educational institution'],
    persona_definition: intl.t('profile_categorization.persona.descriptions.non_profit'),
    imageUrl: 'https://images.unsplash.com/photo-1560252811-2ab1e44ce202?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
    example: intl.t('profile_categorization.persona.examples.non_profit')
  }];
  _exports.getBusinessModels = getBusinessModels;
});